<template>
  <div class="contacts-body">
    <loader :isShow="isLoading" />
    <div class="prelist">
      <span class="title">Housemates</span>
      <span class="contacts-screen-menu-subcontainer">
        <span id="contacts-search">
          <input
            placeholder="Search housemate"
            type="text"
            id="contacts-search-input"
            name="lname"
            v-model="searchInput"
          />
          <img id="contacts-search-img" src="../../assets/search.svg" />
        </span>
        <v-popover
          class="trigger"
          offset="16"
          :auto-hide="true"
          placement="bottom-start"
        >
          <button class="contacts-filter-button">
            <span>Properties</span>
            <img class="down-arrow" src="@/assets/DownGreyArrow.svg" />
          </button>
          <template slot="popover">
            <GenericSearchCheckBoxMenu
              @property-checked="filterProperties"
              :checked="filteredProperties"
              displayProperty="internalName"
              :things="properties"
              class="contacts-property-filter-container"
              searchThing="property"
              :key="'contacts-property-filter'"
            />
          </template>
        </v-popover>
        <button id="create-new" v-on:click="showPopup">New Housemate</button>
      </span>
    </div>
    <div class="contacts-container">
      <div class="contacts-tabs">
        <div
          id="present"
          class="contacts-tabs-option"
          :class="{ selected: tabSelected == 'Present' }"
          @click="tabSelected = 'Present'"
        >
          Active
        </div>
        <div
          id="future"
          class="contacts-tabs-option"
          :class="{ selected: tabSelected == 'Future' }"
          @click="tabSelected = 'Future'"
        >
          Upcoming
        </div>
        <div
          id="past"
          class="contacts-tabs-option"
          :class="{ selected: tabSelected == 'Past' }"
          @click="tabSelected = 'Past'"
        >
          Past
        </div>
      </div>
      <List
        :tabSelected="tabSelected"
        @create="showPopup"
        @contactsUpdated="reload()"
        @loading="isLoading = $event"
        :key="listKey"
        :filteredProperties="filteredProperties"
        :searchInput="searchInput"
      />
      <div v-if="showNewPopup">
        <NewHouseMatePopup
          @submitted="reload()"
          :isEditing="false"
          @cancel="hidePopup"
          @loading="isLoading = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
import List from '@/components/contacts/List'
import NewHouseMatePopup from '@/components/contacts/NewHousematePopup'
import GenericSearchCheckBoxMenu from '@/components/GenericSearchCheckBoxMenu.vue'
import Loader from '@/components/Loader.vue'
import calls from '@/api/calls'

export default {
  name: 'ContactsScreen',
  components: {
    List,
    NewHouseMatePopup,
    GenericSearchCheckBoxMenu,
    Loader
  },
  data() {
    return {
      properties: [],
      filteredProperties: [],
      selProperty: {},
      searchInput: '',
      showNewPopup: false,
      listKey: 0,
      tabSelected: 'Present',
      propertiesFilterSelected: false,
      mouseCoordsProperties: null,
      isLoading: false
    }
  },
  methods: {
    propertiesFilterClicked() {
      this.propertiesFilterSelected = !this.propertiesFilterSelected
      const el = this.$refs['contacts-filter-button']
      this.mouseCoordsProperties = {
        x: el.getBoundingClientRect().x,
        y: el.getBoundingClientRect().y
      }
    },
    styleFilterProperties() {
      return {
        left: this.mouseCoordsProperties.x + 'px',
        top: this.mouseCoordsProperties.y + 48 + 'px'
      }
    },
    filterProperties(id) {
      if (this.filteredProperties.includes(id)) {
        const index = this.filteredProperties.indexOf(id)
        this.filteredProperties.splice(index, 1)
      } else {
        this.filteredProperties.push(id)
      }
    },
    async reload() {
      this.hidePopup()
      this.$forceUpdate()
      await this.loadData()
      this.listKey += 1
    },
    async loadData() {
      this.isLoading = true
      const { data } = await calls.GET('properties')
      this.properties = data
      this.isLoading = false
    },
    hidePopup() {
      this.showNewPopup = false
    },
    showPopup() {
      this.showNewPopup = true
    }
  },
  async beforeMount() {
    await this.loadData()
  }
}
</script>
<style scoped>
.contacts-body {
  padding: 24px;
  background-color: #f5f6f8;
  overflow: hidden;
}

.contacts-container {
  background-color: white;
  height: 80%;
  overflow: hidden;
  margin-bottom: 30px;
}

.prelist {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  margin-bottom: 17px;
}
.title {
  width: 293px;
  height: 32px;

  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 40px;
  /* or 167% */

  display: flex;
  align-items: center;
  letter-spacing: 0.8px;
  color: #000000;
}

button {
  /* Color / Rentalios */
  background: #66b015;
  border-radius: 4px;
}
#create-new {
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
  height: 40px;
  width: 212px;
  left: 0px;
  top: 0px;
  border-radius: 4px;
  margin-left: 6px;
  border-width: 0px;
}

#create-new:hover {
  cursor: pointer;
}

#contacts-select {
  height: 40px;
  width: 140px;
  left: 1084px;
  top: 112px;
  border-radius: 4px;
  padding: 12px;
  margin-right: 6px;
  color: #767675;
  border-color: #cbd4dc;
}
#contacts-select:hover {
  cursor: pointer;
}
.contacts-screen-menu-subcontainer {
  display: flex;
  flex-flow: row nowrap;
}
#contacts-search {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
#contacts-search-input {
  height: 40px;
  width: 200px;
  border-width: 1px;
  border: 1px solid #cbd4dc;
  border-radius: 4px;
  padding-left: 16px;
  margin-right: 4px;
}
#contacts-search-img {
  height: 25px;
  width: 25px;
  position: absolute;
  right: 16px;
}

.contacts-tabs {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 30%;
}

.contacts-tabs-option {
  height: 24px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: #767675;
  padding: 24px;
  margin-left: 40px;
  margin-right: 40px;
  cursor: pointer;
}

.contacts-tabs-option.selected {
  color: var(--rentalios-dark);
  border-bottom: solid var(--rentalios-dark) 2px;
  height: 22px;
}
.contacts-filter-button {
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #cbd4dc;
  box-sizing: border-box;
  border-radius: 4px;
  width: 120px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 11px 12px 11px 15px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  align-items: center;
  color: #767675;
}

.contacts-filter-button.selected {
  background: #ffffff;
  border: 1px solid #66b015;
  color: #66b015;
}
.contacts-property-filter-container {
  position: absolute;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .contacts-body {
    padding: 16px;
    overflow: auto;
  }

  .contacts-container {
    height: auto;
    overflow: visible;
    margin-bottom: 20px;
  }

  .prelist {
    flex-direction: column;
    gap: 16px;
    margin-bottom: 20px;
  }

  .title {
    width: 100%;
    height: auto;
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 8px;
  }

  .contacts-screen-menu-subcontainer {
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  #contacts-search {
    width: 100%;
  }

  #contacts-search-input {
    width: 100%;
    height: 44px;
    font-size: 16px; /* Prevents zoom on iOS */
  }

  .contacts-filter-button {
    height: 44px;
    justify-content: space-between;
    font-size: 16px;
  }

  #create-new {
    width: 90vw;
    height: 44px;
    font-size: 16px;
    margin-left: 0;
  }

  .contacts-tabs {
    width: 100%;
    justify-content: space-around;
    margin: 0;
    padding: 0 16px;
  }

  .contacts-tabs-option {
    padding: 16px 8px;
    margin: 0;
    font-size: 13px;
    flex: 1;
    text-align: center;
  }

  .contacts-tabs-option.selected {
    height: auto;
    padding-bottom: 14px;
  }

  /* Ensure proper table scrolling on mobile */
  .contacts-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Properties select dropdown mobile styling */
  .contacts-filter-button {
    width: 93vw !important;
    box-sizing: border-box !important;
  }

  /* Trigger class for dropdown button */
  .trigger {
    width: 100% !important;
    display: flex !important;
  }
}

@media (max-width: 480px) {
  .contacts-body {
    padding: 12px;
  }

  .title {
    font-size: 18px;
    line-height: 24px;
  }

  .contacts-tabs {
    padding: 0 8px;
  }

  .contacts-tabs-option {
    padding: 12px 4px;
    font-size: 12px;
  }

  /* Additional mobile optimizations */
  #contacts-search-input {
    height: 40px;
    font-size: 16px;
  }

  .contacts-filter-button {
    height: 40px;
    font-size: 16px;
  }

  #create-new {
    height: 40px;
    font-size: 16px;
  }
}
</style>
